/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExportType {
    Combined = 1,
    Raw = 2,
    ExcelOnly = 3,
}
